/* Street Pup Co. v2 homepage behaviours (spc.js). Vanilla, no libraries, loaded with defer.
   - IntersectionObserver: adds .is-in to drips, gold rules, headline masks, cards (sticker slap)
   - Mural parallax (transform only, rAF-throttled, only while on screen)
   - Product-card hover swap: loads the hover image lazily on first hover (desktop only)
   - Ticker: tap to pause/resume
   - Drop countdown to a FIXED date from the section setting (never resets; shows "Out now" after)
   Everything respects prefers-reduced-motion. Safe to load more than once. */
(function () {
  'use strict';
  if (window.__spcInit) return; window.__spcInit = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('spc-js');

  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  /* 1. Reveal on scroll */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;
  function watch(c) {
    qsa('[data-spc-reveal],[data-spc-rule],.spc-drip,.spc-card', c).forEach(function (el) {
      if (!io || reduce) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* 2. Mural parallax */
  var murals = [], ticking = false;
  function parallax() {
    ticking = false;
    var vh = window.innerHeight;
    murals.forEach(function (m) {
      var r = m.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height); /* -0.5..0.5 */
      m.firstElementChild.style.transform = 'translate3d(0,' + (p * -16).toFixed(2) + '%,0)';
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }
  function initMurals(c) {
    if (reduce) return;
    qsa('[data-spc-parallax]', c).forEach(function (m) { if (murals.indexOf(m) < 0) murals.push(m); });
    if (murals.length) parallax();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* 3. Hover swap (fine pointers only; image fetched on first hover) */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function initCards(c) {
    if (!canHover) return;
    qsa('.spc-card.has-hover', c).forEach(function (card) {
      if (card.__spc) return; card.__spc = true;
      function load() {
        var img = card.querySelector('.spc-card__hover[data-spc-src]');
        if (!img) return;
        img.onload = function () { img.classList.add('is-loaded'); };
        if (img.getAttribute('data-spc-srcset')) img.srcset = img.getAttribute('data-spc-srcset');
        img.src = img.getAttribute('data-spc-src');
        img.removeAttribute('data-spc-src');
      }
      card.addEventListener('pointerenter', load, { once: true });
      card.addEventListener('focusin', load, { once: true });
    });
  }

  /* 4. Ticker tap to pause */
  function initTickers(c) {
    qsa('.spc-ticker', c).forEach(function (t) {
      if (t.__spc) return; t.__spc = true;
      t.addEventListener('click', function () { t.classList.toggle('is-paused'); });
    });
  }

  /* 5. Countdown to a fixed release time */
  var timers = [];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdowns(c) {
    qsa('[data-spc-countdown]', c).forEach(function (el) {
      if (el.__spc) return; el.__spc = true;
      var t = Date.parse(el.getAttribute('data-spc-countdown'));
      if (isNaN(t)) return; /* bad date: leave the static date text, no timer */
      var u = {}; ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = el.querySelector('[data-u="' + k + '"]'); });
      function tick() {
        var left = Math.floor((t - Date.now()) / 1000);
        if (left <= 0) { el.classList.add('is-live'); clearInterval(id); return; }
        if (u.d) u.d.textContent = Math.floor(left / 86400);
        if (u.h) u.h.textContent = pad(Math.floor(left % 86400 / 3600));
        if (u.m) u.m.textContent = pad(Math.floor(left % 3600 / 60));
        if (u.s) u.s.textContent = pad(left % 60);
      }
      var id = setInterval(tick, 1000); timers.push(id); tick();
    });
  }

  function init(c) { watch(c); initMurals(c); initCards(c); initTickers(c); initCountdowns(c); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  /* Theme editor: re-init a section when it is added or re-rendered */
  d.addEventListener('shopify:section:load', function (e) {
    murals = murals.filter(function (m) { return d.body.contains(m); });
    init(e.target);
  });
})();
